import { ContactsApiService } from "../../api";
import { ContactsService } from "../../services/contacts.service";
import { USER_CONTACTS_STATE } from "../tokens/contacts.token";

export const provideContacts = () => [
  ContactsApiService,
  ContactsService,
  {
    provide: USER_CONTACTS_STATE,
    useFactory: (contacts: ContactsService) => contacts.state,
    deps: [ContactsService],
  },
];
